// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__Lukzz","card":"page_card__6lFcs","cardContainer":"page_cardContainer__vZ0d4"};